import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import { connect } from "react-redux";
import { setAutoLineupGenBarOpenFlag } from "../../../redux/GameInformation/GameInformationAction";

import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";

import { FlashOnIcon } from "../../../utils/icons";
import "./AutoLineUp.css";
import { getStatsColumnMapping } from "../../../utils/columnsJsonInformation";
import { get_actual_stat_name } from "../../../utils/lineupUtils";

import { browserHistory } from "react-router";
import Grid from "@material-ui/core/Grid";

import Slider from "@material-ui/core/Slider";
import Input from "@material-ui/core/Input";

import axios from "axios";
import { get_auto_lineups_url } from "../../../utils/lineupApiUtils";
import { findSportByLeague, getUserJwtToken } from "../../../utils/utils";

import { getID } from "../../../firebase";
import {
  getExcludedPlayerForSlate,
  getLockedPlayerForSlate,
} from "../../../firestoreQueries";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 750,
    marginLeft: theme.spacing(2),
  },
  input: {
    width: 42,
    color: "white",
  },
  appBar: {
    position: "relative",
    background: "#6C757D", //bg-dark of bootstrap
    color: "white",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function AutoLineUpDialog(props) {
  const classes = useStyles();
  const [exposureValue, setExposureValue] = React.useState(70);
  const [lineupCounts, setLineupCounts] = React.useState(2);
  const [optimizer, setOptimizer] = React.useState("PFP");
  const [showLoader, setShowLoader] = React.useState(false);

  const [open, setOpen] = React.useState(
    props.game_information_info.gameInformationReducer
      .auto_lineup_gen_bar_open_flag
  );

  const handleSliderChange = (event, newValue, type) => {
    if (type === "lineup_counts") {
      setLineupCounts(newValue);
    } else if (type === "exposure") {
      setExposureValue(newValue);
    }
  };
  const handleInputChange = (event, type) => {
    if (type === "lineup_counts") {
      setLineupCounts(
        event.target.value === "" ? "" : Number(event.target.value)
      );
    } else if (type === "exposure") {
      setExposureValue(
        event.target.value === "" ? "" : Number(event.target.value)
      );
    }
  };
  console.log("OpenFlag", open);
  const handleBlur = (type) => {
    if (type === "lineup_counts") {
      if (lineupCounts < 1) {
        setLineupCounts(1);
      } else if (lineupCounts > 11) {
        setLineupCounts(11);
      }
    } else if (type === "exposure") {
      if (exposureValue < 0) {
        setExposureValue(0);
      } else if (exposureValue > 100) {
        setExposureValue(100);
      }
    }
  };
  const handleClose = () => {
    props.update_auto_lineup_generation_flag(false);
  };
  const gotoLineupHome = async () => {
    setShowLoader(true);
    console.log("Lineup API Optimizer", optimizer);
    const userID = getID();
    const lockedPlayers = await getLockedPlayerForSlate(userID, props.slate_id);
    const excludedPlayers = await getExcludedPlayerForSlate(
      userID,
      props.slate_id
    );
    // const lockedPlayers = await fetchLockedFavDeletedPlayers();
    // const lockedExcludedPlayers = await fetchLockedFavDeletedPlayers();
    // const lockedPlayers = lockedExcludedPlayers.locked;
    // const excludedPlayers = lockedExcludedPlayers.excluded;
    let data;
    if (props.league !== undefined && props.league !== null) {
      const sport = findSportByLeague(props.league, props.remoteConfig, "auto lineup gotolineuphome");

      if (lockedPlayers.length > 0 || excludedPlayers.length > 0) {
        data = {
          data: {
            slate_id: props.slate_id,
            league: props.league,
            n: lineupCounts,
            optimizer: get_actual_stat_name(
              optimizer,
              props.league,
              props.remoteConfig
            ),
            locked_players: lockedPlayers,
            excluded_players: excludedPlayers,
            sport: sport.toLowerCase(),
          },
        };
      } else {
        data = {
          data: {
            slate_id: props.slate_id,
            league: props.league,
            n: lineupCounts,
            optimizer: get_actual_stat_name(
              optimizer,
              props.league,
              props.remoteConfig
            ),
            sport: sport.toLowerCase(),
          },
        };
      }

      console.log("LineupDataToSend", data);
      const getAutoLineupData = async () => {
        const token = await getUserJwtToken();
        try {
          const result = await axios.post(get_auto_lineups_url(), data, {
            headers: {
              "Authorization": token,
              // ClientID: process.env.REACT_APP_COGNITO_CLIENT_ID,
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*"
            },
          });
          return result;
        } catch (e) {
          console.log(e);
          alert(e.response.data);
          return null;
        }
      };
      const autoLineupData = await getAutoLineupData();

      console.log("LineupData", autoLineupData);

      if (autoLineupData !== null) {
        const route =
          "/app/" + props.league + "/" + props.slate_id + "/lineups/auto";

        setShowLoader(false);

        browserHistory.push({
          pathname: route,
          state: {
            data: autoLineupData.data,
            myLineups: false,
            recommendationLineups: false,
          },
        });
      }
    }
  };

  return (
    <div>
      {showLoader ? (
        <>
          <Backdrop className={classes.backdrop}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </>
      ) : (
        <></>
      )}
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              Lineup Options
            </Typography>
            <Button className="btn text-white" onClick={gotoLineupHome}>
              Generate{" "}
              <span>
                <FlashOnIcon className="text-yellow" />
              </span>
            </Button>
          </Toolbar>
        </AppBar>
        <List className="bg-dark h-100 text-white">
          {/* <Tour></Tour> */}
          <ListItem className="">
            <ListItemText
              primary={
                <Typography className="font-weight-bold text-white">
                  Number of Lineups
                </Typography>
              }
            />
            <div className={classes.root}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs>
                  <Slider
                    min={1}
                    max={11}
                    value={typeof lineupCounts === "number" ? lineupCounts : 0}
                    onChange={(e, v) =>
                      handleSliderChange(e, v, "lineup_counts")
                    }
                    aria-labelledby="input-slider"
                  />
                </Grid>
                <Grid item>
                  <Input
                    className={classes.input}
                    value={lineupCounts}
                    margin="dense"
                    onChange={(e) => handleInputChange(e, "lineup_counts")}
                    onBlur={() => handleBlur("lineup_counts")}
                    inputProps={{
                      step: 1,
                      min: 1,
                      max: 11,
                      type: "number",
                      "aria-labelledby": "input-slider",
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText
              primary={
                <Typography className="font-weight-bold text-white">
                  Optimizer Type
                </Typography>
              }
            />
            <div class="dropdown">
              <button
                class="btn btn-secondary dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {optimizer}
              </button>
              <div
                class="dropdown-menu bg-secondary "
                aria-labelledby="dropdownMenuButton"
              >
                {props.league &&
                  getStatsColumnMapping(props.league, props.remoteConfig)
                    .filter((column) => column.lineup_param == true)
                    .map((stats, index) => (
                      <li
                        key={index}
                        class="dropdown-item text-white"
                        onClick={() => {
                          setOptimizer(stats.display_name);
                        }}
                      >
                        {stats.display_name}
                      </li>
                    ))}
              </div>
            </div>
          </ListItem>
          <Divider />
        </List>
      </Dialog>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    game_information_info: state,
    league: state.gameInformationReducer.sports,
    slate_id: state.gameInformationReducer.slate_id,
    remoteConfig: state.rcReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    update_auto_lineup_generation_flag: (value) =>
      dispatch(setAutoLineupGenBarOpenFlag(value)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AutoLineUpDialog);
